import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-484fe3a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-col",
  style: {"align-items":"flex-start"}
}
const _hoisted_2 = { class: "flex-center" }
const _hoisted_3 = { style: {"margin-right":"4px","font-weight":"500","font-size":"14px"} }
const _hoisted_4 = { style: {"width":"335px","padding":"6px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin":"0 4px 0 2px","cursor":"pointer"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/restore_help.svg"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"32px"},
  src: "https://static-jp.theckb.com/static-asset/choice/new_icon.png",
  alt: ""
}, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "smartTime"
}
const _hoisted_8 = { class: "header" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/dialog_header_icon.svg",
  alt: ""
}, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "body"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "operate" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "flex-ter" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "body"
}
const _hoisted_17 = { class: "tipsBox" }
const _hoisted_18 = { class: "tips" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"16px","height":"16px","vertical-align":"sub"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/restore_caution.svg",
  alt: ""
}, null, -1))
const _hoisted_20 = { class: "flex-bwn" }
const _hoisted_21 = { class: "zaitu" }
const _hoisted_22 = { class: "flex-end" }

import { request } from '@/config/request/interceptors'
import { t } from '@/plugins/i18n'
import { CustomerShopOptDTO, CustomerShopRespDTO } from '@/service/customer'
import store from '@/store'
import { ElMessage } from 'element-plus'
import { computed, onMounted, ref, toRaw } from 'vue'


export default /*#__PURE__*/_defineComponent({
  emits: ['change', 'refresh'],
  setup(__props, { emit: emits }) {



const isEdit = ref(false)
const visible = ref(false)
const loading = ref(false)
const beforeChangeFn = () => {
  shopInfo.value = { ...showInfo.value, replenishTimeList: showInfo.value?.replenishTimeList?.length ? showInfo.value?.replenishTimeList : ['10:00'] }
  visible.value = true
  isEdit.value = false
  return false
}

const showReplenishTime = computed(() => {
  return showInfo?.value?.replenishTimeList
    ?.map(time => {
      // 匹配:之前的数字部分
      const hourMatch = time.match(/^(\d+):/);
      // 提取数字并转换为整数（自动去除前导零），格式化为"X 点"
      return hourMatch ? t('X时').replace('X', parseInt(hourMatch[1], 10)) : ''
    })
    .join(',')
})
const shopInfoData = computed(() => store.getters.shopReplenishInfo)
// 编辑信息
const shopInfo = ref<CustomerShopOptDTO>({ replenishTimeList: ['10:00'] })
// 原始数据
const showInfo = ref<CustomerShopRespDTO>()
// 获取配置
const getAutoOrder = async () => {
  await store.dispatch('status/setShopReplenishInfo')
  shopInfo.value = {
    smartReplenishFlag: shopInfoData.value?.smartReplenishFlag,
    replenishTimeList: shopInfoData.value?.replenishTimeList ?? ['10:00']
  }
  showInfo.value = shopInfoData.value
}

// 编辑
const editSmart = () => {
  isEdit.value = true
  shopInfo.value = {
    replenishTimeList: [...(showInfo.value?.replenishTimeList ?? ['10:00'])],
    smartReplenishFlag: showInfo.value?.smartReplenishFlag
  }
  visible.value = true
}

onMounted(async () => {
  getAutoOrder()
})

// 保存
const sureConfig = async () => {
  console.log(shopInfo.value.replenishTimeList?.length, [...new Set(shopInfo.value.replenishTimeList)]?.length)
  if (shopInfo.value.replenishTimeList?.length !== [...new Set(shopInfo.value.replenishTimeList)]?.length) {
    return ElMessage.error(t('定时节点不能同一时间'))
  }
  if (!shopInfo.value.smartReplenishFlag) {
    if (shopInfo.value.replenishTimeList?.some(i => i === '')) {
      return ElMessage.error(t('请选择定时节点'))
    }
    const res = await request.customer.customer.shopAutoOrderSwitch({ replenishTimeList: shopInfo.value.replenishTimeList?.sort(), smartReplenishFlag: 1, customerShopId: store.getters.curShop, customerShopUseOnTheWayStockFlag: 1 })
    if (!res.success) return
  } else {
    if (shopInfo.value.replenishTimeList?.some(i => i === '') && isEdit.value) {
      return ElMessage.error(t('请选择定时节点'))
    }
    const res2 = await request.customer.customer.shopAutoOrderSwitch({ customerShopUseOnTheWayStockFlag: shopInfo.value.customerShopUseOnTheWayStockFlag, smartReplenishFlag: isEdit.value ? 1 : 0, customerShopId: store.getters.curShop, replenishTimeList: shopInfo.value.replenishTimeList?.sort() })
    if (!res2.success) return
  }
  if (shopInfo.value.smartReplenishFlag) {
    emits('refresh')
  }
  ElMessage.success(t('保存成功'))
  visible.value = false
  emits('change')
  getAutoOrder()
}


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('智能补货计划')), 1),
        _createVNode(_component_el_tooltip, {
          effect: "light",
          placement: "top",
          "popper-class": "tool-tip-no-border"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('每天定时计算api订单中待补货的数量，汇总生成一笔待支付囤货单，无需单笔订单直接去采购，可以根据销量辅助决策做囤货计划。')), 1)
          ]),
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_switch, {
          loading: loading.value,
          "model-value": !!showInfo.value?.smartReplenishFlag,
          onClick: beforeChangeFn
        }, null, 8, ["loading", "model-value"]),
        _hoisted_6
      ]),
      (showInfo.value?.smartReplenishFlag)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
            _createTextVNode(_toDisplayString(_unref(t)('每日X生成').replace('X', _unref(showReplenishTime))) + " ", 1),
            _createElementVNode("a", { onClick: editSmart }, _toDisplayString(_unref(t)('修改')) + " >", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_dialog, {
      width: 480,
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
      "destroy-on-close": "",
      draggable: "",
      "custom-class": "RestockBtnDialog"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_space, { wrap: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "large",
                round: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                size: "large",
                color: "#000",
                type: "primary",
                round: "",
                onClick: sureConfig
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(!shopInfo.value.smartReplenishFlag ? _unref(t)('确认开启') : (isEdit.value ? _unref(t)('确认修改') : _unref(t)('确认关闭并生成最新补货计划'))), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(isEdit.value ? _unref(t)('修改定时') : (!shopInfo.value.smartReplenishFlag ? _unref(t)('开启集成采购计划') : _unref(t)('关闭智能补货计划'))), 1)
        ]),
        (!shopInfo.value.smartReplenishFlag || isEdit.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (!isEdit.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    innerHTML: _unref(t)('集成采购计划功能上线后，系统将改变原有的逐单采购模式，转为按设定周期自动汇总需求。在指定时间段内生成的API订单将暂不下单，而是由系统整合为集合采购单，用户可对建议补货数量进行调整，以实现更精准的库存管控。该功能有助于企业稳定在库水平，提高订单履约时效，同时避免产生过高库存压力。用户只需设定好补货截止时间，系统将在该节点自动生成优化的采购计划，提升采购效率与库存健康度。')
                  }, null, 8, _hoisted_11))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('定时节点')) + "：", 1),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_el_space, { class: "fx-1" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopInfo.value.replenishTimeList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "rel",
                          key: index
                        }, [
                          _createVNode(_component_el_time_select, {
                            style: {"width":"100%"},
                            size: "large",
                            modelValue: shopInfo.value.replenishTimeList![index],
                            "onUpdate:modelValue": ($event: any) => ((shopInfo.value.replenishTimeList![index]) = $event),
                            start: "00:00",
                            step: "01:00",
                            end: "23:00",
                            placeholder: _unref(t)('请选择')
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                          (index > 0)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "deleteIcon",
                                onClick: () => shopInfo.value.replenishTimeList?.splice(index, 1),
                                src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/restore_close.svg",
                                alt: ""
                              }, null, 8, _hoisted_15))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  (shopInfo.value.replenishTimeList?.length != 3)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "addBtn",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (shopInfo.value.replenishTimeList?.push('')))
                      }, _toDisplayString(_unref(t)('新增定时')), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", null, _toDisplayString(_unref(t)('关闭后，会为您更新一条补货计划，后续的订单将不计入到补货计划，API订单没有匹配到库存将自动走采购流程。')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(_unref(t)('您是否要关闭使用在途库存？关闭后则囤货单支付后不会自动匹配直发单，当囤货单商品采购完成上架后才可以匹配直发单。')), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('使用在途库存')) + "：", 1),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: shopInfo.value.customerShopUseOnTheWayStockFlag,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shopInfo.value.customerShopUseOnTheWayStockFlag) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('开启')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('关闭')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ])
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})